import PropTypes from 'prop-types';
import { AutocompleteTypeNames } from './autocomplete-types';
export var value = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  description: PropTypes.string,
  type: PropTypes.oneOf(AutocompleteTypeNames)
});
export var valueList = PropTypes.arrayOf(value);
export var size = PropTypes.oneOf(['normal', 'large']);
export var types = PropTypes.arrayOf(PropTypes.oneOf(AutocompleteTypeNames));
export var tabs = PropTypes.objectOf(types);
export var inputType = PropTypes.oneOf(['standalone', 'form', 'form-no-button']);
export var variants = PropTypes.oneOf(['dropdown', 'modal']);
export var buildGroupName = PropTypes.func;
export var extensions = PropTypes.shape({
  suggestionHeading: PropTypes.node,
  modalSuggestionSheet: PropTypes.node,
  modalPlaceholder: PropTypes.node
});